import { Injectable } from '@angular/core';
import { AppConstants } from '../../../constants/app.constants';
import { environment } from '../../../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PlanChangeRequestModel } from '../../../models/company.model';
import { Observable } from 'rxjs';

@Injectable()

export class CompanyPlansService {
  baseUrl: string = AppConstants.accessBaseUrl;
  API_KEY = environment.secreteKey;
  private readonly headers = new HttpHeaders({ 'x-api-key': this.API_KEY, 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private readonly http: HttpClient) { }

  changePlanRequest(changePlanData: PlanChangeRequestModel): Observable<any> {
    return this.http.post(this.baseUrl + 'Company/' + AppConstants.changePlanRequest, JSON.stringify(changePlanData), this.options);
  }
}
